import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { ILanguages, TLanguageIDs } from 'types';
import { useTranslation } from 'react-i18next';

interface IValueField {
	languageData: ILanguages;
	changeValues: (languageId: TLanguageIDs, value: string) => void;
}

const ValueField: React.FC<IValueField> = ({ languageData, changeValues }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterValue') }], [t]);

	const handleChange = (value: string) => {
		changeValues(languageData.id, value);
	};

	return (
		<FormInput
			testId={`ValueField-${languageData.name}`}
			name={`value-${languageData.id}`}
			label={`${languageData.name}Text`}
			onChange={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ValueField);
